import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../components/ui';

export default function Calendario() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-100 pb-10">
      <div className="max-w-5xl mx-auto px-4 pt-8">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">
          Calendario interno
        </h1>
        <p className="text-sm text-gray-600 mb-6">
          Gestisci giustificativi di ferie e ROL e mantieni aggiornate le festività aziendali.
        </p>

        <div className="grid md:grid-cols-2 gap-5">
          {/* Box Giustificativi */}
          <Card className="shadow-sm p-5 flex flex-col justify-between">
            <div>
              <h2 className="text-lg font-semibold text-gray-800">
                Giustificativi Ferie / ROL
              </h2>
              <p className="text-sm text-gray-500 mt-1">
                Inserisci e consulta richieste di ferie, permessi e ROL per tutti i dipendenti.
              </p>
            </div>
            <div className="mt-4">
              <button
                type="button"
                onClick={() => navigate('/calendario/giustificativi')}
                className="px-4 py-2 rounded-lg bg-blue-600 text-white text-sm font-semibold hover:bg-blue-700"
              >
                Gestisci giustificativi
              </button>
            </div>
          </Card>

          {/* Box Calendario */}
          <Card className="shadow-sm p-5 flex flex-col justify-between">
            <div>
              <h2 className="text-lg font-semibold text-gray-800">
                Calendario aziendale
              </h2>
              <p className="text-sm text-gray-500 mt-1">
                Imposta le festività annuali e visualizza le presenze del personale.
              </p>
            </div>
            <div className="mt-4">
              <button
                type="button"
                onClick={() => navigate('/calendario/azienda')}
                className="px-4 py-2 rounded-lg bg-indigo-600 text-white text-sm font-semibold hover:bg-indigo-700"
              >
                Vai al calendario
              </button>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
}
